import * as notifier from './notifier.js';
import * as loader from './loader.js';
import * as coverage from '../xhr/coverage.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @returns {function(*=): Promise<any | never>}
 */
export function sendQuery(query) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return coverage
            .sendQuery(query)
            .then((response) => {
                setLoader(dispatch, false);
                return response;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}